export { deepmerge } from './deepmerge';
export { logFormErrors } from './logger';

export function chunk(arr: any[], size: number): any[] {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
}

export function guid() {
  const a = new Uint32Array(3);
  window.crypto.getRandomValues(a);
  return (
    performance.now().toString(36) +
    Array.from(a)
      .map(A => A.toString(36))
      .join('')
  ).replace(/\./g, '');
}

export function weekendsDatesFilter(d: Date | null): boolean {
  d = new Date(d ? d : '');
  const day = d?.getDay();
  return day !== 0 && day !== 6;
}

export function isLocal(): boolean {
  const loc: Location = window.location;
  return loc.port !== '' || loc.hostname.includes('localhost');
}

export function isDev(): boolean {
  const loc: Location = window.location;
  return loc.port !== '' || loc.hostname.endsWith('-dev.azurewebsites.net');
}

export function isUat(): boolean {
  return window.location.hostname.endsWith('-uat.equitygroupholdings.com');
}

export function isProd(): boolean {
  return window.location.hostname.endsWith('-prod.equitygroupholdings.com');
}

export function isDevOrUat(): boolean {
  return isDev() || isUat();
}
